import { render } from "./Show.vue?vue&type=template&id=53516ec8&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=53516ec8&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53516ec8"],['__file',"resources/js/pages/eleve/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53516ec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53516ec8', __exports__)) {
    console.log('reload')
    api.reload('53516ec8', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=53516ec8&scoped=true", () => {
    console.log('re-render')
    api.rerender('53516ec8', render)
  })

}


export default __exports__